module.exports = __webpack_public_path__ + "/login_ui/img/alert-50f9a6d7343af9554e41c20cacca1641.svg";